import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-pb-container',
    templateUrl: './pb-container.component.html',
    styleUrls: ['./pb-container.component.scss']
})
export class PbContainerComponent implements OnInit {

    @Input() content: any = {};

    constructor() { }

    ngOnInit(): void {

        try {
            this.content = JSON.parse(this.content);
        } catch (err) {
            this.content = {};
        }

    }

}
